import * as React from "react";
import { Button } from "@rumble-it/common-components/components";

const FormSubmitButton = React.forwardRef(
  ({ className, isSubmitting, children, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        loading={isSubmitting}
        className={className}
        type="submit"
        {...props}
      >
        {children}
      </Button>
    );
  },
);

export { FormSubmitButton };
